'use es6';

import AsyncData from 'conversations-async-data/async-data/AsyncData';
import { DATA, STATUS } from 'conversations-async-data/async-data/constants/keyPaths';
import { getData, getStatus } from 'conversations-async-data/async-data/operators/getters';
import { getEntries } from 'conversations-async-data/indexed-async-data/operators/getters';
import { Map as ImmutableMap } from 'immutable';
import { createSelector } from '@reduxjs/toolkit';
import setIn from 'transmute/setIn';
import { getResponders } from '../../responders/selectors/getResponders';
import { isSystemUserResponder } from '../../responders/operators/filterSystemUserResponders';
import { getResponderAsSender } from '../operators/getResponderAsSender';
import { getResponderKeyAsSenderLocator } from '../operators/getResponderKeyAsSenderLocator';
export const getSendersMap = createSelector([getResponders], respondersIndexedAsyncData => {
  return getEntries(respondersIndexedAsyncData).reduce((sendersMap, responderAsyncData, responderKey) => {
    const responder = getData(responderAsyncData);
    if (responder && isSystemUserResponder(responder)) {
      return sendersMap;
    }
    return setIn([getResponderKeyAsSenderLocator(responderKey)], AsyncData({
      [DATA]: responder ? getResponderAsSender(responder) : null,
      [STATUS]: getStatus(responderAsyncData)
    }), sendersMap);
  }, ImmutableMap());
});